var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBhipLogo = function SvgBhipLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 832,
    height: 384
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".bhip-logo_svg__a{fill:#fff}.bhip-logo_svg__b{fill:#0f3e5f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 136.2c0 14.8-12 26.8-26.8 26.8s-26.8-12-26.8-26.8c0-14.7 12-26.7 26.8-26.7s26.8 12 26.8 26.7M280 247.9c0 14.8-12 26.7-26.8 26.7s-26.8-11.9-26.8-26.7 12-26.7 26.8-26.7 26.8 11.9 26.8 26.7",
    className: "bhip-logo_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M589.7 293.9h-44.9l.3-208.7H590zM594.3 27.9c0 14.7-12 26.7-26.8 26.7s-26.8-12-26.8-26.7c0-14.8 12-26.8 26.8-26.8s26.8 12 26.8 26.8",
    className: "bhip-logo_svg__b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M215.1 192.1c0 59-48 106.9-107.3 106.9S.5 251.1.5 192.1L.4.8H45l.1 84.3h62.7c59.3 0 107.3 47.9 107.3 107m-44.7 0c0-34.5-28-62.4-62.6-62.4H45.1l.1 62.4c0 34.4 28 62.4 62.6 62.4s62.6-28 62.6-62.4",
    className: "bhip-logo_svg__a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m518.1 293.9-.2-105.4h-.1c-1.9-57.4-49.2-103.4-107.2-103.4h-62.8V.8h-44.6v293.1h44.7l-.1-164.2h62.8c34.4 0 62.3 27.7 62.6 61.9v102.3z",
    className: "bhip-logo_svg__b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M724.7 299H662l-.1 84.3h-44.7l.2-191.3c0-59 48-106.9 107.3-106.9S832 133 832 192c0 59.1-48 107-107.3 107m0-169.4c-34.6 0-62.6 28-62.6 62.4l-.1 62.4h62.7c34.6 0 62.6-27.9 62.6-62.4 0-34.4-28-62.4-62.6-62.4",
    className: "bhip-logo_svg__b"
  })));
};
export default SvgBhipLogo;